import React, { FC, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Account from "assets/Icons/Account.svg";
import { UserMenuProps } from "pages/Dashboard/types";
import I18nKey from "translations/I18nKey";
import { useIntl } from "react-intl";
import { removeToken } from "store/auth/auth.slice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "router/types";
import { AppState } from "store/types";
import { changeValue } from "store/SellerOnboarding/sellerOnboarding.slice";
import { snakeToCamelCase } from "utils/utils";
import { persistor } from "index";
import { changeIsUserActive } from "store/Dashboard/dashboard.slice";
import { CircularProgress } from "@mui/material";
import { REACT_APP_MASTER_ADMIN } from "constants/constants";

interface BillingResponse {
  configuration: string;
  created: number;
  customer: string;
  flow: any;
  id: string;
  livemode: boolean;
  locale: any;
  object: string;
  on_behalf_of: any;
  return_url: string;
  url: string;
}

const companyIdtoIngore = "ca5bc57f-62b4-4cd2-8508-78fb302e190a";

export const UserMenu: FC<UserMenuProps> = ({ name, role, sessionLogin }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { subscription, token, user } = useSelector(
    (state: AppState) => state.auth
  );

  const [billingInfoLoading, setBillingInfoLoading] = useState(false);
  const getStripeDetails = async () => {
    setBillingInfoLoading(true);
    fetch(
      "https://boooimlpr5.execute-api.us-east-1.amazonaws.com/prod/customers/billing-portal/",
      {
        headers: {
          Authorization: token,
        },
      }
    )
      .then((response) => response.text())
      .then((data) => {
        const respData: BillingResponse = JSON.parse(data)?.data;
        window.open(respData.url);
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setBillingInfoLoading(false);
      });
  };

  const showBillingInfo =
    subscription?.status && user?.user?.companyId !== companyIdtoIngore;

  return (
    <Box
      sx={{
        background: "#FFFFFF",
        boxShadow: "0px 10px 10px rgba(0, 0, 0, 0.1)",
        borderRadius: "4px",
        paddingBottom: "0px",
        width: "200px",
        height: "auto",
      }}
    >
      <Box
        sx={{
          background: "rgba(25, 118, 210, 0.12)",
          opacity: "0.5",
          borderRadius: "4px 4px 0px 0px",
          padding: "15px 30px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: "28.69px",
              height: "28.7px",
              margin: "3.65px 39px 5px 41px",
            }}
          >
            <img src={Account} alt="account" />
          </Box>
          <Box>
            <Typography
              sx={{
                fontFamily: "Lato",

                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "16px",
                lineHeight: "20.8px",
                // alignItems: 'center',
                textAlign: "center",
                color: "black",
                marginBottom: "5px",
              }}
            >
              {name}
            </Typography>
          </Box>
          <Box
            sx={{ margin: "2px 0px 0px 2px", width: "109px", height: "21px" }}
          >
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{
                fontFamily: "Lato",
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "16.8px",
                // alignItems: 'center',
                textAlign: "center",
                color: "#757575",
              }}
            >
              {role}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          borderBottom: "1px solid #DBDBDB",
          padding: "8px 12px",
        }}
      >
        {subscription?.status && (
          <>
            <Box sx={{ padding: "8px 12px 0 12px", cursor: 'pointer' }} onClick={()=> navigate(ROUTES.Products)}>
              <Typography
                sx={{
                  fontFamily: "Lato",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "12px",
                  lineHeight: "14.06px",

                  color: "#424242",
                }}
              >
                Manage Subscription
              </Typography>
            </Box>
            <Box sx={{ padding: "4px 12px 8px 12px" }}>
              <Typography
                sx={{
                  fontFamily: "Lato",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: "12px",
                  lineHeight: "14.06px",

                  color: "#757575",
                }}
              >
                {/* {sessionLogin} */}
                {snakeToCamelCase(subscription?.status)}
              </Typography>
            </Box>
          </>
        )}
      </Box>
      {/* <Box
        sx={{
          padding: "12px",
          cursor: "pointer",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Lato",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "15.6px",

            color: "#0D47A1",
          }}
        >
          {intl.formatMessage({
            id: I18nKey.SETTINGS,
          })}
        </Typography>
      </Box> */}
      {showBillingInfo && (
        <Box
          sx={{
            padding: "12px 12px 10px 12px",
            cursor: "pointer",
          }}
        >
          <a
            style={{
              fontFamily: "Lato",
              fontStyle: "normal",
              fontWeight: 400,
              fontSize: "12px",
              lineHeight: "15.6px",
              color: billingInfoLoading ? "grey" : "#0D47A1",
              textDecoration: "none",
            }}
            onClick={(e) => {
              if (billingInfoLoading) {
                e.preventDefault();
              } else {
                getStripeDetails();
              }
            }}
          >
            {intl.formatMessage({
              id: I18nKey.BILLING_INFO,
            })}{" "}
            {billingInfoLoading && <CircularProgress size={12} />}
          </a>
        </Box>
      )}
      <Box
        sx={{
          padding: showBillingInfo
            ? "0px 12px 10px 12px"
            : "12px 12px 10px 12px",
          cursor: "pointer",
        }}
        onClick={() => {
          dispatch(changeValue(2));
          // navigate(ROUTES.Sellers);
          window.location.href = ROUTES.Sellers;
        }}
      >
        <Typography
          sx={{
            fontFamily: "Lato",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "15.6px",
            color: "#0D47A1",
          }}
        >
          {intl.formatMessage({
            id: I18nKey.USER_MENU_SELLER,
          })}
        </Typography>
      </Box>
      {role === "CompanyAdmin" ? (
        <>
          <Box
            sx={{
              padding: "0px 12px 10px 12px",
              cursor: "pointer",
            }}
            onClick={() => {
              window.location.href = ROUTES.Users;
            }}
          >
            <Typography
              sx={{
                fontFamily: "Lato",
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "12px",
                lineHeight: "15.6px",
                color: "#0D47A1",
              }}
            >
              {intl.formatMessage({
                id: I18nKey.USERS,
              })}
            </Typography>
          </Box>
        </>
      ) : null}
      {(user?.user?.name === REACT_APP_MASTER_ADMIN) && <Box
            sx={{
              padding: "0px 12px 10px 12px",
              cursor: "pointer",
            }}
            onClick={() => {
              window.location.href = ROUTES.Analytics;
            }}
          >
            <Typography
              sx={{
                fontFamily: "Lato",
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "12px",
                lineHeight: "15.6px",
                color: "#0D47A1",
              }}
            >
              {intl.formatMessage({
                id: I18nKey.ANALYTICS,
              })}
            </Typography>
          </Box>}
      <Box
        sx={{
          padding: "0 12px 12px 12px",
          cursor: "pointer",
        }}
        onClick={() => {
          dispatch(removeToken());
          dispatch(changeIsUserActive(-1));
          persistor.purge();
          navigate(ROUTES.Landing);
        }}
      >
        <Typography
          sx={{
            fontFamily: "Lato",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "15.6px",
            color: "#0D47A1",
          }}
        >
          {intl.formatMessage({
            id: I18nKey.LOGOUT,
          })}
        </Typography>
      </Box>
    </Box>
  );
};
